import { ChangeDetectorRef, DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ResizeObserverService } from '@core/services/resize-observer.service';

@Directive()
export class LoadingSkeletonBaseClass {
  readonly #elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  readonly #resizeObserverService = inject(ResizeObserverService);
  readonly #cdr = inject(ChangeDetectorRef);
  readonly #destroyRef = inject(DestroyRef);

  public hostWidth!: number;
  public hostHeight!: number;

  constructor() {
    this.hostWidth = this.#elementRef.nativeElement.offsetWidth;
    this.hostHeight = this.#elementRef.nativeElement.offsetHeight;

    this.#resizeObserverService
      .observe$(this.#elementRef.nativeElement)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => {
        this.hostWidth = this.#elementRef.nativeElement.offsetWidth;
        this.hostHeight = this.#elementRef.nativeElement.offsetHeight;
        this.#cdr.markForCheck();
      });
  }
}
